import OrganizationAddress from './organization_address';

export default OrganizationAddress;
